/*
 *   File : date-picker.js
 *   Author : https://evoqins.com
 *   Description : Date picker component
 *   Integrations : react-calendar
 *   Version : 1.0.0
*/

import React, { useEffect, useRef, useState } from 'react';
import Calendar from 'react-calendar';
import { format } from "date-fns";
import 'react-calendar/dist/Calendar.css';

// custom component 
import { OverLay } from '../Other';

//custom style
import styles from "../../Style/Component/calender.module.scss";

// Assets
import CalenderIcon from "../../Assets/Images/KYC/calendar.svg";

const DatePicker = (props) => {

    const calendarRef = useRef(null);

    const [value, setValue] = useState(new Date());
    const [showValue, setShowValue] = useState("");
    const [showCalender, setShowCalender] = useState(false);
    const [floatingLabel, setFloatingLabel] = useState(false);

    useEffect(() => {
        if (props.showCalender === false) {
            setShowCalender(props.showCalender);
        }
    }, [props.showCalender]);

    useEffect(() => {
        if (props.value) {
            setValue(format(props.value, "MM/dd/yyyy"));
            setShowValue(format(props.value, "dd MM yyyy").replaceAll(" ", "-"));
            setFloatingLabel(true);
        } else {
            if (props.activeDate) {
                setValue(props.activeDate);
            } else {
                setShowValue("");
                setValue(new Date());
            }

        };

    }, [props.value]);


    useEffect(() => {

        if (showCalender === true) {
            const react_calendar = document.querySelector("#calender-wrapper");
            react_calendar.scrollIntoView({ behavior: "smooth", block: "end" });
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = 'unset';
        }


        // Floating label state update
        if (showCalender) {
            setFloatingLabel(true);
        } else {
            if (showValue === "" && props.value === "") {
                setFloatingLabel(false);
            }
        }

    }, [showCalender]);

    //handle onchange date
    const _handleOnChangeDate = (date) => {
        setValue(date);
        setShowValue(format(date, "dd MM yyyy").replaceAll(" ", "-"));
        props.onChange(date);
        setShowCalender(false);
    };

    const _handleShowCalender = () => {
        setShowCalender((show_calender) => {
            if (props.handleCloseCalendar) {
                props.handleCloseCalendar(!show_calender);
            }
            return !show_calender
        });
    };

    // format day according to the design
    function formatWeekDay(locale, date) {
        const day_format = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
        const day_index = date.getDay();
        const formatted_day = day_format[day_index];
        return formatted_day;
    };

    return (
        <div className='position-relative' ref={calendarRef}>

            <div id='calender'
                className={`${props.floatingLabel ? "padding-16px-tb" : "padding-12px-tb"}  padding-12px-tb-res position-relative      ${styles.e_input_wrapper} ${showCalender === true ? "e-border-otp-active" : "e-border-1px-sonic-silver"} ${props.error && "border-red-1px"} position-relative ${props.wrapperClassName}`}
                onClick={_handleShowCalender}>

                {props.label &&
                    <label className={`${props.labelStyle} ${floatingLabel ? "focused pe-none" : ""} floating-label e-text-dark-charcoal e-font-weight-400 e-alt-font-poppins line-height-24px e-font-14`} >
                        {props.label}
                        {props.require && <span className='e-text-sunset-orange'>*</span>}
                    </label>
                }

                {showCalender === false ?
                    <img src={CalenderIcon}
                        draggable={false}
                        width={16}
                        height={16}
                        className='top-6px-res position-absolute right-16px top-50 translate-middle-y'
                        alt='calender' />
                    :
                    <img src={require("../../Assets/Images/close-btn.svg").default}
                        draggable={false}
                        width={16}
                        height={16}
                        className='top-6px-res position-absolute right-16px top-50 translate-middle-y'
                        alt='calender' />
                }

                {/* Displayed value */}
                <p className={`${showValue.length === 0 ? " e-text-lavender-gray e-font-14" : "e-text-charleston-green e-font-16 e-font-weight-500"} ${props.floatingLabel ? "e-font-weight-500" : "e-font-weight-400"}    e-font-14-res padding-12px-lr line-height-22px  e-alt-font-poppins  mb-0 `}>
                    {showValue.length !== 0 ? showValue : "19-03-2001"}&nbsp;
                </p>

            </div>
            {props.error &&
                <div className='position-absolute d-flex align-items-center e-error left-0'>
                    <p className={`e-text-red e-font-12 mb-0`}>{props.error}</p>
                </div>
            }

            {/* Background overlay */}
            {
                showCalender === true &&
                <>
                    <OverLay isOpen={showCalender} onClose={_handleShowCalender} overLay={false} />
                    <div id='calender-wrapper'
                        className={`${styles.e_calender} e-calender position-absolute pb-4`}>
                        <Calendar value={value}
                            minDate={props.minDate}
                            maxDate={props.maxDate}
                            nextLabel=">"
                            next2Label={null}
                            prevLabel="<"
                            prev2Label={null}
                            showNeighboringMonth={false}
                            // navigationLabel={({ date, label, locale, view }) => { return label.split(' ')[0] }}
                            locale="en-IN"
                            formatShortWeekday={formatWeekDay}
                            onChange={_handleOnChangeDate} />
                    </div>
                </>
            }
        </div>
    )
}

export default DatePicker;